import { styled } from "@mui/material";
import { Link } from "react-router-dom";
export const Section = styled("main")(({ theme }) => (props) => ({
  padding: "24px  96px  ",
  display: "flex",
  [theme.breakpoints.down("md")]: {
    padding: "24px  48px  ",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "12px  24px  ",
    flexDirection: "column",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "6px 12px  ",
  },
  minHeight: "75vh",
}));
export const RightSection = styled("section")(({ theme }) => (props) => ({

}));
export const LeftSection = styled("section")(({ theme }) => (props) => ({
  flex: '1',
  padding: "24px",
  height: "40vh",
  [theme.breakpoints.down("md")]: {
    width: "60%",
    padding: "12px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    padding: "12px",
  },
}));
export const TextHeading = styled("h6")(({ theme }) => (props) => ({
  borderTop: `1px solid #82828252 `,
  padding: "32px 16px 0",
  margin: "0 0  14px 0",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0em",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const ContentComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  marginTop: "24px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));
export const LinkComp = styled("div")(({ theme }) => (props) => ({
  padding: "0 10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  marginTop: '16px',
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 0",
  },
}));
export const LinkText = styled(Link)(({ theme }) => (props) => ({
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0em",
  display: "flex",
  alignItems: "center",
  gap: "5px",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const UserComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  width: "288px",
  borderRadius: '12px',
  background: '#F4F4F4',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '32px',
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    justifyContent: "center",
    borderBottom: "1px solid #e5e5e5",
    borderRight: "none",
    padding: "  12px",
  },
}));
export const TextUserComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  marginTop: '8px',

}));
export const TextUserInfo = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  gap: "10px",
  alignItems: "center",
}));
export const TextEmail = styled("p")(({ theme }) => (props) => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "0",
  letterSpacing: "0em",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.dark,
}));
export const TextVerify = styled("p")(({ theme }) => (props) => ({
  display: "flex",
  alignItems: "center",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "0",
  letterSpacing: "0em",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.darkSecondary,
}));
export const TextPhone = styled("p")(({ theme }) => (props) => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "0",
  letterSpacing: "0em",
  direction: 'rtl',
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.darkSecondary,
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));
export const UserImage = styled("div")(({ theme }) => (props) => ({
  width: "96px",
  height: "96px",
  minWidth: "80px",
}));
export const Image = styled("img")(({ theme }) => (props) => ({
  width: "100%",
  height: "100%",
  borderRadius: "50%",
}));
export const TextUser = styled("h6")(({ theme }) => (props) => ({
  margin: " 0",
  fontSize: "18px",
  fontWeight: 500,
  lineHeight: "0",
  letterSpacing: "0em",
  textAlign: 'center',
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const TextDecoration = styled("h6")(({ theme }) => (props) => ({
  margin: "5px",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  padding: "10px 16px 0",
  background: '#F2F2F2',
  borderRadius: '4px',
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.text.dark,
}));

export const CompInfo = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  gap: "16px",
  flexWrap: "wrap",
  padding: "24px 12px",
}));

export const CardInfo = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  padding: "24px 32px",
  borderRadius: theme.shape.borderRadius,
  flexBasis: "23%",
  background:
    theme.palette.mode === "light"
      ? theme.palette.background.lightSecondary
      : theme.palette.background.darkSecondary,
  [theme.breakpoints.down("md")]: {
    flexBasis: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    flexBasis: "100%",
    padding: "12px 16px",
    alignItems: "center",
  },
  [theme.breakpoints.down("xs")]: {
    alignItems: "start",
  },
}));
export const CardHeading = styled("h5")(({ theme }) => (props) => ({
  margin: "8px 0",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "29px",
  letterSpacing: "0em",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const CardDisc = styled("p")(({ theme }) => (props) => ({
  margin: "0",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0em",
}));
